import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
// Get your config from: Firebase Console → Project Settings → General → Your apps → Web app
const firebaseConfig = {
  apiKey: "AIzaSyC7RHxXzG5pYZxJgQBw8mBqKZQ6XqYfOZg",
  authDomain: "cannaverum-site.firebaseapp.com",
  projectId: "cannaverum-site",
  storageBucket: "cannaverum-site.firebasestorage.app",
  messagingSenderId: "123456789",
  appId: "1:123456789:web:abcdef123456"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;
